import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface FishingFeesFiltersState {
  titleSearch: string;
  categoryId: number | null;
  showSoftDeleted: boolean;
  showSoftDeletedCategories: boolean;
}

const initialState: FishingFeesFiltersState = {
  titleSearch: '',
  categoryId: null,
  showSoftDeleted: false,
  showSoftDeletedCategories: false,
};

const fishingFeesFiltersSlice = createSlice({
  name: 'fishingFeesFilters',
  initialState,
  reducers: {
    setTitleSearch(state, action: PayloadAction<string>) {
      state.titleSearch = action.payload;
    },
    setCategoryId(state, action: PayloadAction<number | null>) {
      state.categoryId = action.payload;
    },
    setShowSoftDeleted(state, action: PayloadAction<boolean>) {
      state.showSoftDeleted = action.payload;
    },
    setShowSoftDeletedCategories(state, action: PayloadAction<boolean>) {
      state.showSoftDeletedCategories = action.payload;
    },
    resetFilters(state) {
      state.titleSearch = initialState.titleSearch;
      state.categoryId = initialState.categoryId;
      state.showSoftDeleted = initialState.showSoftDeleted;
    },
  },
});

export const { setTitleSearch, setCategoryId, setShowSoftDeleted, setShowSoftDeletedCategories, resetFilters } =
  fishingFeesFiltersSlice.actions;

export const areFiltersAppliedSelector = (state: { fishingFeesFilters: FishingFeesFiltersState }) => {
  const { titleSearch, categoryId, showSoftDeleted } = state.fishingFeesFilters;
  return !!titleSearch || categoryId !== null || showSoftDeleted;
};

export const activeFiltersCountSelector = (state: { fishingFeesFilters: FishingFeesFiltersState }) => {
  const { titleSearch, categoryId, showSoftDeleted } = state.fishingFeesFilters;
  let count = 0;
  if (titleSearch) count++;
  if (categoryId !== null) count++;
  if (showSoftDeleted) count++;
  return count;
};

export const areCategoryFiltersAppliedSelector = (state: { fishingFeesFilters: FishingFeesFiltersState }) =>
  state.fishingFeesFilters.showSoftDeletedCategories;

export const activeCategoryFiltersCountSelector = (state: { fishingFeesFilters: FishingFeesFiltersState }) =>
  state.fishingFeesFilters.showSoftDeletedCategories ? 1 : 0;

export const fishingFeesFiltersActions = fishingFeesFiltersSlice.actions;

export const fishingFeesFilters = fishingFeesFiltersSlice.reducer;
